import axios from "axios";

/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Data
 *
 * Purpose: get data from backend
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 22Mar2022 craig File created.
 \******************************************************************************/
import {AxiosError} from "axios";

type ServerError = { errorMessage: string };
//const navigate = useNavigate();

export function getDataPost(url: string, values: string) {
    axios.defaults.withCredentials = true;
    return axios.post(url, values,
        {
            withCredentials: true,
            "headers": {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
        .then(response => response.data)
        .catch(error => {
            if (axios.isAxiosError(error)) {
                const serverError = error as AxiosError<ServerError>;
                if (serverError && serverError.response) {
                    if (serverError.response.status === 403) {
                        window.location.href = "/error/403";
                    }
                    else if (serverError.response.status === 500) {
                        window.location.href = "/error/500";
                    }
                }
            }
        })
}

export function getDataGet(url: string) {
    axios.defaults.withCredentials = true;
    return axios.get(url,
        {
            withCredentials: true,
        })
        .then(response => response.data)
        .catch(error => {
            if (axios.isAxiosError(error)) {
                const serverError = error as AxiosError<ServerError>;
                if (serverError && serverError.response) {
                    if (serverError.response.status === 403 || serverError.response.status === 404) {
                        window.location.href = "/error/403";
                    }
                }
            }

            return {errorMessage: "Kuch to ghotala h"};
        })
}